import { chapterizeLanguagesAPIs } from "./chapterizeLanguagesAPIs";

const aiGatewayAPI = {
  ...chapterizeLanguagesAPIs,
};

export default aiGatewayAPI;
